import React, { useEffect, useState } from "react";
import "./FreeTrail.scss";

import { RxCross2 } from "react-icons/rx";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { CiUnlock, CiDollar } from "react-icons/ci";
import { MdOutlineNotificationsActive } from "react-icons/md";

import { useDispatch, useSelector } from "react-redux";
import { updateFreeTrailStatus } from "../../../redux/features/subscription-slice";
import { Link, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import CustomButton from "../../../components/CustomButton/CustomButton";

const FreeTrail = () => {
  const { plans: subsPlans, free_trail: openBanner } = useSelector(
    (state) => state.subscriptionReducer.value
  );

  const { run } = useSelector((state) => state.tourReducer.value);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [proPlan, setProPlan] = useState(null);
  const [openSecondBanner, setOpenSecondBanner] = useState(false);

  useEffect(() => {
    const pro = subsPlans?.find((el) => el?.name === "Pro");

    if (pro) {
      setProPlan(pro);
    }
  }, [subsPlans]);

  const handleClose = () => {
    dispatch(updateFreeTrailStatus({ free_trail: false }));
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (openBanner && !run) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [openBanner, run, isVisible]);

  if (!shouldRender) return null;

  return (
    <>
      {openSecondBanner ? (
        <div className={`free-trail-banner ${isVisible ? "active" : ""}`}>
          <div className="heading">
            <p>Pro Plan Free Trail started!</p>
          </div>
          <p className="desc">
            Your free trial for 30 days of Pro plan has been started. You can
            use all the features of the app during the phase. After the trial
            period is over, you will only be able to use the free features.
          </p>

          <h1>Free free to upgrade your account anytime.</h1>

          <div className="plan-list">
            {subsPlans
              ?.filter((el) => el?.name !== "Free")
              ?.map((plan, i) => {
                return (
                  <div className="item" key={i}>
                    <p className="name">{plan?.name}</p>
                    <div className="price">
                      <p>${plan?.pricing?.monthly?.price}</p>
                      <span>per month</span>
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="buttons">
            <button
              className=""
              type="button"
              onClick={() => {
                handleClose();
                navigate(ROUTES.upgrade.path);
              }}
            >
              Learn More
            </button>
            <button className="primary" type="button" onClick={handleClose}>
              Continue
            </button>
          </div>
        </div>
      ) : (
        <div
          className={`free-trail-whole-page ${
            openBanner && !run ? "active" : ""
          }`}
        >
          <div className="free-trail-wrapper">
            <div className="top">
              <p>How your free trail works</p>
              <div
                className="svg"
                onClick={() => {
                  setOpenSecondBanner(true);
                }}
              >
                <RxCross2 />
              </div>

              <div className="side-lines"></div>
            </div>

            <div className="middle">
              <div className="item">
                <div className="svg">
                  <IoCheckmarkDoneOutline />
                </div>

                <div className="content">
                  <p className="crossed">Install the app</p>
                  <span>You successfully created your profile.</span>
                </div>
                <div className="side-lines"></div>
              </div>

              <div className="item">
                <div className="svg active">
                  <CiUnlock />
                </div>

                <div className="content">
                  <p>Today: get Instant access</p>
                  <span>Customize and add products.</span>
                </div>
                <div className="side-lines active"></div>
              </div>

              <div className="item">
                <div className="svg">
                  <MdOutlineNotificationsActive />
                </div>

                <div className="content">
                  <p>Day 15: Trail reminder</p>
                  <span>We will send you the reminder notification.</span>
                </div>
                <div className="side-lines"></div>
              </div>

              <div className="item">
                <div className="svg">
                  <CiDollar />
                </div>

                <div className="content">
                  <p>Day 30: Trial ends</p>
                  <span>Your free trail subscription ends.</span>
                </div>
              </div>
            </div>

            <div className="bottom">
              <p>
                Free access for 30 days, then{" "}
                <span>${proPlan?.pricing?.yearly?.price} per year</span>
              </p>
              <CustomButton
                name={`Continue`}
                type={"button"}
                color={"primary"}
                bigButton={true}
                handleSubmit={() => {
                  setOpenSecondBanner(true);
                }}
                disabled={false}
              />
              <p
                className="link"
                onClick={() => {
                  setOpenSecondBanner(true);
                }}
              >
                View all plans
              </p>
            </div>
          </div>
        </div>
      )}
      {isVisible && (
        <div className={"free-trail-back-blur"} onClick={handleClose}></div>
      )}
    </>
  );
};

export default FreeTrail;
